<section *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formImport">
      <div class="row">
        <div class="col-lg-12 col-12">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12 fw-bold">
              <label>Para realizar el proceso de importación de facturas, descargue la guía y siga los pasos:</label>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
              <app-custom-autocomplete formControlName="companyId" [labelText]="'Compañía'" [list]="listCompanies"
                [required]="true" [recovery]="true" (onChangeSelect)="getCompany($event)">
              </app-custom-autocomplete>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
              <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                [required]="true" [recovery]="true" (onChangeSelect)="getBranch($event)">
              </app-custom-select>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
              <app-custom-select formControlName="enterpriseId" [labelText]="'Empresa'" [list]="listEnterprises"
                [required]="true" [recovery]="true" (onChangeSelect)="getEnterprise($event)">
              </app-custom-select>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
              <app-custom-select formControlName="bussinessDocumentsClassId" [labelText]="'Clase'" [list]="listClasses"
                [required]="true" [recovery]="true">
              </app-custom-select>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-12">
              <app-custom-autocomplete formControlName="articleId" [labelText]="'Artículo'" [list]="listArticles">
              </app-custom-autocomplete>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-6 col-12 my-2 my-lg-0 checkbox-container d-flex align-items-end gap-3">
              <app-custom-checkbox formControlName="updateInvoicesZero"
                [labelText]="'Predefinir saldos en 0'"></app-custom-checkbox>

              <app-custom-button [title]="'Información.'" [severity]="'secondary'" [icon]="'pi pi-info-circle'"
                (onClick)="openToggle($event)"></app-custom-button>

              <p-popover #information>
                <div>
                  <div class="">
                    <span>
                      <b>Información</b>
                      <br>
                      Este proceso revisa todas las facturas en el archivo de Excel.
                      <br>
                      Si una factura no existe, se crea automáticamente.
                      <br>
                      Si la factura ya existe, se actualiza con todos los valores diligenciados en el excel.
                      <br>
                      <b>Si selecciona Predefinir saldos en 0:</b>
                      Antes de importar el archivo,
                      <br> el saldo de todas las facturas se establece en 0.
                    </span>
                  </div>
                </div>
              </p-popover>
            </div>

            <div class="col-lg-4 col-md-8 col-sm-12 col-12 d-flex align-items-end my-2 my-md-0 gap-2">
              <app-custom-button [title]="'Seleccionar Archivo'" [label]="'Seleccionar Archivo'" [severity]="'success'"
                [width]="'10rem'" [icon]="'pi pi-upload'" (onClick)="attach()"
                [disabled]="!permissionUpdatable"></app-custom-button>
              <input id="fileImport" type="file" type="file" (change)="getNameFile($event)" hidden>
              <p class="m-0">{{nameFile}}</p>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex align-items-end justify-content-between gap-2 mt-2">
              <app-custom-button [label]="'Descargar Guía Import.'" [severity]="'success'" [width]="'10rem'"
                [disabled]="!permissionUpdatable" (onClick)="downloadGuideImport()"></app-custom-button>
              <app-custom-button [label]="'Importar'" [severity]="'primary'" [disabled]="!permissionUpdatable"
                [variant]="undefined" (onClick)="importInvoices()" [width]="'5rem'"></app-custom-button>
            </div>
          </div>
          <div class="row">
            <div id="list" *ngIf="visibleTxt">
              <h6>Lista de Errores y Alertas</h6>
              <p>Total errores: {{invoiceAlerts.length}}</p>
              <div id="container-alerts" *ngFor="let invoiceAlert of invoiceAlerts">
                <p [ngClass]="errorInvoice == 1 ? 'message-error' : 'message-alert'">
                  {{invoiceAlert.message}}
                </p>
              </div>
            </div>
            <div class="row" *ngIf="visibleTxt">
              <div class="d-flex justify-content-end">
                <app-custom-button [title]="'Exportar'" [label]="'Exportar'" [icon]="'pi pi-file-export'"
                  [width]="'5.5rem'" (onClick)="downloadErrorsTxt()"></app-custom-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>